import React, { useState, useEffect } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { config } from '../../config';

export default function GererPages() {
  const { idCours } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [pages, setPages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [newPageTitle, setNewPageTitle] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [coursTitre, setCoursTitre] = useState(location.state?.titreCours || 'Cours');

  // Utilisation de la configuration centralisée
  const API_BASE = config.apiBase;
  const getToken = () => localStorage.getItem('token');

  const fetchPages = async () => {
    try {
      const token = getToken();
      const response = await fetch(`${API_BASE}/enseignant/cours/get_pages_cours.php?id_cours=${idCours}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await response.json();
      if (data.success) setPages(data.pages);
    } catch (error) {
      toast.error('Erreur de chargement');
    } finally {
      setLoading(false);
    }
  };

  const createPage = async () => {
    if (!newPageTitle.trim()) { toast.error('Titre requis'); return; }
    setSubmitting(true);
    try {
      const token = getToken();
      const response = await fetch(`${API_BASE}/enseignant/cours/creer_page.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify({ id_cours: idCours, titre_page: newPageTitle })
      });
      const data = await response.json();
      if (data.success) {
        toast.success('Page créée');
        setNewPageTitle('');
        setShowForm(false);
        fetchPages();
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      toast.error('Erreur');
    } finally {
      setSubmitting(false);
    }
  };

  useEffect(() => { fetchPages(); }, [idCours]);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="text-center"><div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div><p className="mt-4 text-gray-600">Chargement...</p></div>
      </div>
    );
  }

  return (
    <div className="p-6 max-w-7xl mx-auto">
      <div className="flex justify-between items-center mb-6">
        <div><button onClick={() => navigate('/enseignant/cours')} className="text-blue-600 hover:text-blue-700 mb-2 flex items-center gap-1">← Retour aux cours</button><h1 className="text-2xl font-bold text-gray-800">📄 Pages du cours</h1><p className="text-sm text-gray-500">{coursTitre}</p></div>
        <button onClick={() => setShowForm(!showForm)} className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition flex items-center gap-2"><span className="text-lg">+</span> Nouvelle page</button>
      </div>

      {showForm && (
        <div className="bg-white rounded-xl shadow-lg p-6 mb-6 border">
          <h2 className="text-lg font-bold mb-4">➕ Créer une page</h2>
          <div className="flex gap-3"><input type="text" value={newPageTitle} onChange={(e) => setNewPageTitle(e.target.value)} placeholder="Titre de la page" className="flex-1 border rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500" /><button onClick={createPage} disabled={submitting} className="bg-green-600 text-white px-6 py-2 rounded-lg hover:bg-green-700 disabled:opacity-50">{submitting ? 'Création...' : 'Créer'}</button><button onClick={() => setShowForm(false)} className="bg-gray-200 text-gray-700 px-6 py-2 rounded-lg hover:bg-gray-300">Annuler</button></div>
        </div>
      )}

      {pages.length === 0 ? (
        <div className="bg-white rounded-xl shadow-md p-12 text-center"><div className="text-5xl mb-4">📄</div><p className="text-gray-500">Aucune page</p><button onClick={() => setShowForm(true)} className="mt-3 text-blue-600 hover:underline">Créez votre première page</button></div>
      ) : (
        <div className="space-y-3">
          {pages.map((page, index) => (
            <div key={page.id_page} className="bg-white rounded-lg shadow-md p-4 hover:shadow-lg transition border">
              <div className="flex justify-between items-center">
                <div className="flex items-center gap-4"><div className="w-8 h-8 rounded-full bg-blue-100 text-blue-600 flex items-center justify-center font-bold">{index + 1}</div><div><h3 className="font-semibold text-gray-800">{page.titre}</h3><p className="text-xs text-gray-400">Créée le {new Date(page.date_creation).toLocaleDateString()}{page.date_modification !== page.date_creation && ` • Modifiée le ${new Date(page.date_modification).toLocaleDateString()}`}</p></div></div>
                <div className="flex gap-2"><button onClick={() => navigate(`/enseignant/cours/${idCours}/pages/${page.id_page}/editer`)} className="text-blue-600 hover:text-blue-700 px-3 py-1 rounded-lg hover:bg-blue-50">✏️ Modifier</button><button onClick={async () => { if (confirm('Supprimer cette page ?')) { const token = getToken(); await fetch(`${API_BASE}/enseignant/cours/delete_page.php`, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }, body: JSON.stringify({ id_page: page.id_page }) }); toast.success('Page supprimée'); fetchPages(); } }} className="text-red-500 hover:text-red-700 px-3 py-1 rounded-lg hover:bg-red-50">🗑️ Supprimer</button></div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}